import { createApi } from '@reduxjs/toolkit/query/react';

import { TAG_RACES } from '../../config/tags';
import { SCHEDULE_RACES } from '../../config/urls';
import { adaptRaces } from '../adapters/races';

import { baseQuery } from './baseQuery';

import type { Race } from '../types';
import type { ApiRace } from '../types/apiRace';
import type { Lang } from '@assets/locales';

export type RacesArgs = {
  startDate: string;
  endDate: string;
  racecourseCode?: string;
  language: Lang;
  size?: number;
};

// Define a service using a base URL and expected endpoints
export const racesApi = createApi({
  reducerPath: 'racesApi',
  tagTypes: [TAG_RACES],
  baseQuery,
  refetchOnFocus: true,
  endpoints: builder => ({
    getRaces: builder.query<Race[], RacesArgs>({
      query: arg => ({
        url: SCHEDULE_RACES,
        params: { ...arg },
      }),
      transformResponse: (response: ApiRace[]): Race[] => {
        return adaptRaces(response);
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetRacesQuery } = racesApi;
